import ComposableMedicalFormEvaluator from "../Types/ComposableMedicalFormEvaluator";
import IMedicalQuestionnaireCompleteEvaluator from "../Types/IMedicalQualificationCompleteEvaluator";
import IMedicalQualificationNonCandidateEvaluator from "../Types/IMedicalQualificationNonCandidateEvaluator";
import { DiabeticFormEvaluatorConfig } from "./ComposedDiabeticMedicalQuestions";
import { GeneralMedicalQuestionsEvaluatorConfig } from "./ComposedGeneralMedicalQuestions";
import { PacemakerFormEvaluatorConfig } from "./ComposedPacemakerMedicalQuestions";
import { RadiationFormEvaluatorConfig } from "./ComposedRadiationMedicalQuestions";

/** A medical form evaluator capable of analyzing the complete medical form state across all independent steps. */
const AllMedicalQuestionsEvaluator: IMedicalQualificationNonCandidateEvaluator &
  IMedicalQuestionnaireCompleteEvaluator = new ComposableMedicalFormEvaluator({
  allFormQuestionIds: [
    ...GeneralMedicalQuestionsEvaluatorConfig.allFormQuestionIds,
    ...DiabeticFormEvaluatorConfig.allFormQuestionIds,
    ...PacemakerFormEvaluatorConfig.allFormQuestionIds,
    ...RadiationFormEvaluatorConfig.allFormQuestionIds
  ],
  nonCandidateIgnoredQuestionIds: [
    ...(GeneralMedicalQuestionsEvaluatorConfig.nonCandidateIgnoredQuestionIds ?? []),
    ...(DiabeticFormEvaluatorConfig.nonCandidateIgnoredQuestionIds ?? []),
    ...(PacemakerFormEvaluatorConfig.nonCandidateIgnoredQuestionIds ?? []),
    ...(RadiationFormEvaluatorConfig.nonCandidateIgnoredQuestionIds ?? [])
  ],
  requiredQuestionPredicates: {
    ...GeneralMedicalQuestionsEvaluatorConfig.requiredQuestionPredicates,
    ...DiabeticFormEvaluatorConfig.requiredQuestionPredicates,
    ...PacemakerFormEvaluatorConfig.requiredQuestionPredicates,
    ...RadiationFormEvaluatorConfig.requiredQuestionPredicates
  },
  nonCandidateQuestionPredicates: {
    ...GeneralMedicalQuestionsEvaluatorConfig.nonCandidateQuestionPredicates,
    ...DiabeticFormEvaluatorConfig.nonCandidateQuestionPredicates,
    ...PacemakerFormEvaluatorConfig.nonCandidateQuestionPredicates,
    ...RadiationFormEvaluatorConfig.nonCandidateQuestionPredicates
  }
});

export default AllMedicalQuestionsEvaluator;
